import React from 'react';

const emptyFunc = () => {};

/**
 * @type {typeof import('.').DropdownContext}
 */
const DropdownContext = React.createContext({ isOpen: false, isGapless: false, show: emptyFunc, hide: emptyFunc, triggerRef: null, align: 'left' });

export default DropdownContext;
